import React from "react";
import { StyleSheet, View } from "react-native";
import color from "@constants/color";
import Text from "@components/CustomText";
interface CustomerSubCardProps {
  extra_info: any;
}

const CustomerSubCard: React.FC<CustomerSubCardProps> = ({ extra_info }) => {
  return (
    <View style={styles.summaryContainer}>
      {extra_info?.map((item: any) => (
        <View key={item?.title} style={styles.listItem}>
          <Text variant="caption_2" style={styles.titlestyle}>
            {item.title}
          </Text>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            {item?.rating_txt && (
              <Text
                variant="caption_4"
                style={{ marginRight: 8, color: item?.rating_color }}
              >
                {item.rating_txt}
              </Text>
            )}
            <Text variant="body_text_2">{item.value}</Text>
          </View>
        </View>
      ))}
    </View>
  );
};

export default CustomerSubCard;

const styles = StyleSheet.create({
  summaryContainer: {
    backgroundColor: color.white,
    borderRadius: 16,
  },
  listItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 4,
    borderRadius: 16,
    alignItems: "center",
  },
  titlestyle: {
    color: color.black06,
  },
});
